// components/SubHeader.jsx
import React from "react";
import { Typography } from "@mui/material";

const SubHeader = ({ text, styles }) => {
  return (
    <Typography
      variant={styles.subheader?.fontSize || "h6"}
      gutterBottom
      sx={{
        color: styles.subheader?.color || "inherit",
        fontFamily: styles.subheader?.fontFamily || "inherit",
      }}
    >
      {text}
    </Typography>
  );
};

export default SubHeader;
